import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';
import { useQuery } from '@tanstack/react-query';
import {
  getFormParams,
  type WithdrawParamsResponse,
} from '@/features/withdraw-bank-transfer';
import { useAppSettingsStore } from '@/shared/lib';

export function useGetWithdrawParams() {
  const { getLanguage } = useAppSettingsStore();
  const language = getLanguage();

  const queryKey = ['withdrawGetParams', language];

  const query = useQuery<WithdrawParamsResponse, Error>({
    queryKey,
    queryFn: () => getFormParams(),
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
    retry: 0,
  });

  return {
    paramsData: query.data,
    isParamsDataLoading: query.isLoading,
    paramsDataError: query.error,
    query,
  };
}
